import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ProgressSteps from '../components/progress-steps';
import { Button, CheckboxTable, DatePicker, FallbackImage, Input, PaperClip, Select, Textarea } from 'components';
import { Constants, Globals } from 'utils';
import { AddIcon, ArrowLeft, DeleteIcon, TimeIcon } from 'assets/icons';
import { WhiteImage } from 'assets/img';
import { MODAL, STEP, useForm } from './use-form';
import { CheckboxRow, PassInput } from '../components';
import TermsModal from '../components/terms-modal';

const initialProduct = {
  name: '',
  image: '',
  image_blob: '',
};

const initialVet = {
  name: '',
};

const RegisterClinic = () => {
  const { form, getCities, modal, nextStep, onChange, onChangeValue, prevStep, selects, setModal, step } = useForm();

  return (
    <div id="register-affiliate">
      <Link className="back-btn" to="/register/select-level">
        <img src={ArrowLeft} alt="Back" />
      </Link>

      <TermsModal
        level_id={Constants.LEVELS.AFFILIATE}
        visible={modal === MODAL.TERMS}
        onClose={() => setModal(MODAL.NONE)}
      />

      <main>
        <h4>Registro</h4>
        <ProgressSteps activeIndex={step} total={Object.keys(STEP).length} />

        <div className="content">
          {step === STEP.STEP1 && (
            <>
              <section>
                <h5>Datos de la clínica</h5>
                <div className="grid-2 mb-3">
                  <Input
                    className="col-span-2 mb-3"
                    label="Nombre de la empresa"
                    placeholder="Nombre de la empresa"
                    name="name"
                    value={form.name}
                    onChange={onChange}
                  />

                  <div className="container-select">
                    <label>Documento</label>
                    <div>
                      <Select
                        name="document_type_id"
                        value={form.document_type_id}
                        options={selects.document_types}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Documento"
                        name="document"
                        value={form.document}
                        onChange={onChange} />
                    </div>
                  </div>
                  <DatePicker
                    label="Fecha de fundada"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown
                    maxDate={moment().toDate()}
                    minDate={moment('1900-01-01').toDate()}
                    value={form?.birthdate ? moment(form.birthdate).toDate() : null}
                    onChange={(v: Date) => onChangeValue('birthdate', moment(v).format('YYYY-MM-DD'))}
                  />

                  <div className="container-select">
                    <label>Teléfono</label>
                    <div>
                      <Select
                        name="phonecode_id"
                        value={form.phonecode_id}
                        options={selects.phonecodes}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Teléfono"
                        name="phone"
                        value={form.phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <Input
                    label="Correo"
                    placeholder="Correo"
                    name="email"
                    value={form.email}
                    onChange={onChange}
                  />

                  <Select
                    label="Estado"
                    name="state_id"
                    value={form.state_id}
                    options={selects.states}
                    onChange={(e: any) => {
                      onChange(e);
                      onChangeValue('city_id', '');
                      getCities();
                    }}
                  />
                  <Select
                    label="Ciudad"
                    name="city_id"
                    value={form.city_id}
                    options={selects.cities}
                    onChange={onChange}
                  />
                </div>

                <Textarea
                  label="Dirección"
                  placeholder="Dirección"
                  rows={3}
                  name="address"
                  value={form.address}
                  onChange={onChange}
                />
              </section>

              <br />

              <section>
                <h5>Datos de la persona de contacto</h5>

                <div className="grid-2">
                  <Input
                    label="Nombre"
                    placeholder="Nombre"
                    name="contact_person_name"
                    value={form.contact_person_name}
                    onChange={onChange}
                  />

                  <div className="container-select">
                    <label>Documento</label>
                    <div>
                      <Select
                        name="contact_person_doc_type_id"
                        value={form.contact_person_doc_type_id}
                        options={selects.document_types}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Documento"
                        name="contact_person_document"
                        value={form.contact_person_document}
                        onChange={onChange} />
                    </div>
                  </div>
                  <div className="container-select">
                    <label>Teléfono</label>
                    <div>
                      <Select
                        name="contact_person_phone_code_id"
                        value={form.contact_person_phone_code_id}
                        options={selects.phonecodes}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Teléfono"
                        name="contact_person_phone"
                        value={form.contact_person_phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <Input
                    className="mb-3"
                    label="Correo"
                    placeholder="Correo"
                    name="contact_person_email"
                    value={form.contact_person_email}
                    onChange={onChange}
                  />
                </div>
              </section>

              <br />

              <section>
                <h5>Contraseña</h5>
                <p>Su contraseña debe tener un mínimo de 8 caracteres</p>

                <div className="grid-2">
                  <PassInput
                    label="Contraseña"
                    name="password"
                    onChange={onChange}
                  />
                  <PassInput
                    label="Repetir contraseña"
                    name="password_confirmation"
                    onChange={onChange}
                  />
                </div>

                <div className="terms">
                  <CheckboxTable
                    active={Boolean(form.terms)}
                    onClick={() => onChangeValue('terms', !form.terms)}
                  />
                  <span>
                    <span>Acepto los </span>
                    <span className="highlight" onClick={() => setModal(MODAL.TERMS)}>
                      Términos y condiciones y la política de privacidad
                    </span>
                  </span>
                </div>
              </section>
            </>
          )}

          {step === STEP.STEP2 && (
            <>
              <section>
                <h5>Datos del servicio</h5>
                <div className="d-flex align-items-center">
                  <p className="label mr-4">¿Tienes una especialidad?</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => {
                      onChangeValue('speciality_id', '');
                      setModal(MODAL.SPECIALITY);
                    }}>
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                  {modal === MODAL.SPECIALITY && (
                    <>
                      <div className="select-mb-0 ml-3">
                        <Select
                          className="speciality_select mb-0"
                          name="speciality_id"
                          value={form.speciality_id || ''}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (!val) return;

                            onChangeValue('speciality_id', val);
                            if (val === Constants.SPECIALTIES.OTROS.name) {
                              onChangeValue('speciality_name', '');
                            } else {
                              const item = selects.specialties.find(i => i.value === val);
                              if (!item) return;
                              onChangeValue('specialties', form.specialties.concat([item.label]));
                              onChangeValue('speciality_id', '');
                              setModal(MODAL.NONE);
                            }
                          }}
                          options={[
                            ...(selects.specialties?.filter((i: any) => {
                              return i.value === Constants.SPECIALTIES.OTROS.name
                                ? true
                                : !form.specialties?.some(name => name === i.value)
                            }) || [])
                          ]}
                        />
                      </div>

                      {form.speciality_id === Constants.SPECIALTIES.OTROS.name && (
                        <div className="select-mb-0">
                          <label className="datalist">
                            <input
                              name="speciality_name"
                              onChange={e => onChangeValue('speciality_name', e.target.value)}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const name = form.speciality_name.trim();
                                if (!name) return;

                                // Verifica si el animal ya fue seleccionado
                                const exists = form?.specialties?.find(i => i.name === name);
                                if (exists) return;

                                onChangeValue('specialties', form.specialties.concat([name]));
                                onChangeValue('speciality_id', '');
                                setModal(MODAL.NONE);
                              }}
                            >
                              Guardar
                            </button>
                          </label>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="speciality-list">
                  {form.specialties?.map((name: any, index: number) => (
                    <span
                      key={index}
                      onClick={() => {
                        const data = form.specialties?.filter((_: string, idx: number) => idx !== index);
                        onChangeValue('specialties', data);
                      }}
                    >
                      {name}
                    </span>
                  ))}
                </div>

                <br />

                <div className="d-flex align-items-center">
                  <p className="label mr-4">Idioma(s) hablado(s)</p>
                  <div className="btn-add-mini" onClick={() => setModal(MODAL.LANGUAGE)}>
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                  {modal === MODAL.LANGUAGE && (
                    <div className="select-mb-0 ml-3">
                      <Select
                        className="speciality_select mb-0"
                        name="language_id"
                        value={form.language_id}
                        options={selects.languages?.filter((i: any) => !form.languages?.includes(i.value))}
                        onChange={e => {
                          const data = form.languages?.includes(e.target.value)
                            ? form.languages.filter(i => i !== e.target.value)
                            : form.languages?.concat([e.target.value]);
                          onChangeValue('languages', data);
                          onChangeValue('language_id', '');
                          setModal(MODAL.NONE);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="speciality-list">
                  {form.languages?.map((id: any, index: number) => (
                    <span
                      key={index}
                      onClick={() => {
                        const data = form.languages?.filter((item: string) => item !== id);
                        onChangeValue('languages', data);
                      }}
                    >
                      {String(selects.languages.find((i: any) => i.value === id)?.label)}
                    </span>
                  ))}
                </div>

              </section>

              <section>
                <h5>Áreas de especialización</h5>
                <p>Seleccione el(las) área(s)</p>

                <div className="grid-3">
                  {selects.areas_specialization?.map((item, index) => (
                    <div
                      key={index}
                      className="check-item"
                      onClick={() => {
                        const data = form?.areas_specialization?.includes(item.value)
                          ? form?.areas_specialization?.filter(i => i !== item.value)
                          : form?.areas_specialization?.concat([item.value]);
                        onChangeValue('areas_specialization', data);
                      }}
                    >
                      <CheckboxTable active={form?.areas_specialization?.includes(item.value)} />
                      <p>{item.label}</p>
                    </div>
                  ))}
                </div>

                <br />

                <div className="d-flex align-items-center">
                  <p className="label mr-4">Animales</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => {
                      onChangeValue('animal_id', '');
                      setModal(MODAL.ANIMAL);
                    }}
                  >
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                  {modal === MODAL.ANIMAL && (
                    <>
                      <div className="select-mb-0 ml-3">
                        <Select
                          className="speciality_select mb-0"
                          name="animal_id"
                          value={form.animal_id || ''}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (!val) return;

                            onChangeValue('animal_id', val);
                            if (val === Constants.AFFILIATE_ANIMALS.OTROS.id.toString()) {
                              onChangeValue('animal_name', '');
                            } else {
                              const item = selects.animals.find(i => i.value === val);
                              if (!item) return;
                              onChangeValue('animals_affiliate', form.animals_affiliate.concat([{
                                type: item.value,
                                type_text: item.label,
                                name: null,
                              }]));
                              onChangeValue('animal_id', '');
                              setModal(MODAL.NONE);
                            }
                          }}
                          options={[
                            ...(selects.animals?.filter((i: any) => {
                              return i.value === Constants.AFFILIATE_ANIMALS.OTROS.id.toString()
                                ? true
                                : !form.animals_affiliate?.some(a => a.type === i.value)
                            }) || [])
                          ]}
                        />
                      </div>

                      {form.animal_id === Constants.AFFILIATE_ANIMALS.OTROS.id.toString() && (
                        <div className="select-mb-0">
                          <label className="datalist">
                            <input
                              name="animal_name"
                              onChange={e => onChangeValue('animal_name', e.target.value)}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const name = form.animal_name.trim();
                                if (!name) return;

                                // Verifica si el animal ya fue seleccionado
                                const exists = form?.animals_affiliate?.find(i => i.name === name);
                                if (exists) return;

                                onChangeValue('animals_affiliate', form.animals_affiliate.concat([{
                                  type: Constants.AFFILIATE_ANIMALS.OTROS.id.toString(),
                                  type_text: Constants.AFFILIATE_ANIMALS.OTROS.name,
                                  name,
                                }]));
                                setModal(MODAL.NONE);
                              }}
                            >
                              Guardar
                            </button>
                          </label>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="mb-4 speciality-list">
                  {form.animals_affiliate?.map((i: any, index: number) => {
                    const isCustom = i.type === Constants.AFFILIATE_ANIMALS.OTROS.id.toString();

                    return (
                      <span
                        key={index}
                        onClick={() => {
                          const data = form.animals_affiliate?.filter((_: string, idx: number) => idx !== index);
                          onChangeValue('animals_affiliate', data);
                        }}
                      >
                        {isCustom ? i.name : i.type_text}
                      </span>
                    )
                  })}
                </div>

                <div className="d-flex align-items-center">
                  <p className="label mr-4">Servicios que ofrece</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => {
                      onChangeValue('service_id', '');
                      setModal(MODAL.SERVICE);
                    }}
                  >
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                  {modal === MODAL.SERVICE && (
                    <>
                      <div className="select-mb-0 ml-3">
                        <Select
                          className="speciality_select mb-0"
                          name="service_id"
                          value={form.service_id}
                          onChange={(e) => {
                            onChangeValue('service_id', e.target.value);
                            if (e.target.value === Constants.SERVICES.OTROS.id.toString()) {
                              onChangeValue('service_name', '');
                            } else {
                              const item = selects.services.find(i => i.value === e.target.value);
                              if (!item) return;
                              onChangeValue('services', form.services.concat([{
                                type: item.value,
                                type_text: item.label,
                                name: null,
                              }]));
                              setModal(MODAL.NONE);
                            }
                          }}
                          options={selects.services?.filter((i: any) => {
                            return i.value === Constants.SERVICES.OTROS.id.toString()
                              ? true
                              : !form.services?.some(a => a.type === i.value)
                          })}
                        />
                      </div>

                      {form.service_id === Constants.SERVICES.OTROS.id.toString() && (
                        <div className="select-mb-0">
                          <label className="datalist">
                            <input
                              list="services"
                              name="service_name"
                              autoComplete="none"
                              onChange={e => onChangeValue('service_name', e.target.value)}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const name = form.service_name.trim();
                                if (!name) return;

                                // Verifica si el animal ya fue seleccionado
                                const exists = form?.services?.find(i => i.name === name);
                                if (exists) return;

                                onChangeValue('services', form.services.concat([{
                                  type: Constants.SERVICES.OTROS.id.toString(),
                                  type_text: Constants.SERVICES.OTROS.name,
                                  name,
                                }]));
                                setModal(MODAL.NONE);
                              }}
                            >
                              Guardar
                            </button>
                          </label>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="mb-4 speciality-list">
                  {form.services?.map((i: any, index: number) => {
                    const isCustom = i.type === Constants.SERVICES.OTROS.id.toString();

                    return (
                      <span
                        key={index}
                        onClick={() => {
                          const data = form.services?.filter((_: string, idx: number) => idx !== index);
                          onChangeValue('services', data);
                        }}
                      >
                        {isCustom ? i.name : i.type_text}
                      </span>
                    )
                  })}
                </div>

                <div className="d-flex align-items-center">
                  <p className="label mr-4">Categorías</p>
                  <div className="btn-add-mini" onClick={() => setModal(MODAL.CATEGORY)}>
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                  {modal === MODAL.CATEGORY && (
                    <div className="select-mb-0 ml-3">
                      <Select
                        className="speciality_select mb-0"
                        name="category_id"
                        value={form.category_id}
                        options={selects.categories?.filter((i: any) =>
                          !form.categories?.includes(i.value) && i.label !== 'Clasificados'
                        )}
                        onChange={e => {
                          const data = form?.categories?.includes(e.target.value)
                            ? form?.categories?.filter(i => i !== e.target.value)
                            : form?.categories?.concat([e.target.value]);
                          onChangeValue('categories', data);
                          setModal(MODAL.NONE);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="mb-4 speciality-list">
                  {form.categories?.map((id: any, index: number) => (
                    <span
                      key={index}
                      onClick={() => {
                        const data = form.categories?.filter((item: string) => item !== id);
                        onChangeValue('categories', data);
                      }}
                    >
                      {String(selects.categories.find((i: any) => i.value === id)?.label)}
                    </span>
                  ))}
                </div>
              </section>
            </>
          )}

          {step === STEP.STEP3 && (
            <section>
              <h5>Veterinarios</h5>
              <div className="d-flex align-items-center justify-content-between">
                <p>Agregue los veterinarios que trabajan en la clínica</p>

                <div className="btn-add-mini mb-3" onClick={() => onChangeValue('veterinarians', form.veterinarians.concat([Globals.clone(initialVet)]))}>
                  <img src={AddIcon} alt="Agregar" />
                  <span>Agregar</span>
                </div>
              </div>

              <div className="products">
                {form?.veterinarians?.map((i: any, index: number) => (
                  <div key={index} className="product">
                    <Input
                      color="white name"
                      name="name"
                      placeholder="Nombre"
                      value={i.name}
                      onChange={e => {
                        const data = form.veterinarians.map((i: any, idx: number) => (
                          idx === index ? { ...i, name: e.target.value } : i
                        ));
                        onChangeValue('veterinarians', data)
                      }}
                    />
                    <div className="remove">
                      <img
                        src={DeleteIcon}
                        alt="Eliminar"
                        onClick={() => {
                          const data = form.veterinarians.filter((_, idx: number) => idx !== index);
                          onChangeValue('veterinarians', data);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {step === STEP.STEP4 && (
            <section>
              <h5>Productos</h5>
              <div className="d-flex align-items-center justify-content-between">
                <p>¿Vendes algún producto? (Opcional)</p>

                <div className="btn-add-mini mb-3" onClick={() => onChangeValue('products', form.products.concat([Globals.clone(initialProduct)]))}>
                  <img src={AddIcon} alt="Agregar" />
                  <span>Agregar</span>
                </div>
              </div>

              <div className="products">
                {form?.products?.map((i: any, index: number) => (
                  <div key={index} className="product">
                    <label className="product-wrapper">
                      <FallbackImage
                        src={i?.image_blob}
                        placeholder={WhiteImage}
                        className="product-image"
                        placeholderClassName="product-image"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={e => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          const data = form.products.map((i: any, idx: number) => (
                            idx === index ? { ...i, image: file, image_blob: URL.createObjectURL(file) } : i
                          ));
                          onChangeValue('products', data);
                        }}
                      />
                    </label>
                    <Input
                      color="white name"
                      name="name"
                      placeholder="Nuevo producto"
                      value={i.name}
                      onChange={e => {
                        const data = form.products.map((i: any, idx: number) => (
                          idx === index ? { ...i, name: e.target.value } : i
                        ));
                        onChangeValue('products', data)
                      }}
                    />
                    <div className="remove">
                      <img
                        src={DeleteIcon}
                        alt="Producto"
                        onClick={() => {
                          const data = form.products.filter((_, idx: number) => idx !== index);
                          onChangeValue('products', data);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {step === STEP.STEP5 && (
            <section>
              <h5>Información de consulta</h5>
              <br />
              <h6>Horario de atención</h6>

              <div className="grid-3">
                <DatePicker
                  label="Desde"
                  showTimeSelect={true}
                  showTimeSelectOnly={true}
                  timeCaption="Hora"
                  calendarIcon={TimeIcon}
                  dateFormat="h:mm aa"
                  value={form?.consultation?.init_hour ? moment(form.consultation.init_hour, 'HH:mm:ss').toDate() : null}
                  onChange={(v: Date) => onChangeValue('consultation', { ...form.consultation, init_hour: moment(v).format('HH:mm:ss') })}
                />
                <DatePicker
                  label="Hasta"
                  showTimeSelect={true}
                  showTimeSelectOnly={true}
                  timeCaption="Hora"
                  calendarIcon={TimeIcon}
                  dateFormat="h:mm aa"
                  value={form?.consultation?.end_hour ? moment(form.consultation.end_hour, 'HH:mm:ss').toDate() : null}
                  onChange={(v: Date) => onChangeValue('consultation', { ...form.consultation, end_hour: moment(v).format('HH:mm:ss') })}
                />
              </div>

              <br />

              <p className="label">Días</p>
              <div className="days">
                {selects.weekDays.map((weekday, wIdx) => {
                  const isSelected = form?.consultation?.days?.includes(weekday.value);
                  return (
                    <div
                      key={wIdx}
                      className="day"
                      data-selected={String(isSelected)}
                      onClick={() => {
                        const data = isSelected
                          ? form?.consultation?.days?.filter(i => i !== weekday.value)
                          : form?.consultation?.days?.concat([weekday.value]);
                        onChangeValue('consultation', { ...form.consultation, days: data });
                      }}
                    >
                      {weekday.label}
                    </div>
                  )
                })}
              </div>

              <br />

              <div className="grid-2">
                <Select
                  label="Costo de consulta"
                  className="speciality_select"
                  name="teleconsultation_rate_id"
                  value={form.consultation.teleconsultation_rate_id}
                  options={selects.teleconsultationRates}
                  onChange={(e: any) => onChangeValue('consultation', { ...form.consultation, teleconsultation_rate_id: e.target.value })}
                />
              </div>

              <br />

              <div className="grid-3">
                <div
                  className="check-item"
                  onClick={() => onChangeValue('consultation', { ...form.consultation, home_service: !form.consultation.home_service })}
                >
                  <CheckboxTable active={!!form?.consultation.home_service} />
                  <p>Disponible para consultas a domicilio</p>
                </div>
                <div
                  className="check-item"
                  onClick={() => onChangeValue('consultation', { ...form.consultation, emergency_service: !form.consultation.emergency_service })}
                >
                  <CheckboxTable active={!!form?.consultation.emergency_service} />
                  <p>Presta servicio de emergencia 24 horas</p>
                </div>
                <div
                  className="check-item"
                  onClick={() => onChangeValue('consultation', { ...form.consultation, delivery_service: !form.consultation.delivery_service })}
                >
                  <CheckboxTable active={!!form?.consultation.delivery_service} />
                  <p>Cuenta con servicio de delivery</p>
                </div>
              </div>

              <br />

              <div>
                <label className="contact-method-title">Método de contacto</label>
                <div className="contact-method-list">
                  {selects.contact_methods.map((cm, cmIdx) => {
                    const isSelected = form.consultation.contact_methods.includes(cm.value);
                    return (
                      <div
                        key={cmIdx}
                        className="contact-method"
                        data-selected={String(isSelected)}
                        onClick={() => {
                          const data = isSelected
                            ? form?.consultation?.contact_methods?.filter(i => i !== cm.value)
                            : form?.consultation?.contact_methods?.concat([cm.value]);
                          onChangeValue('consultation', { ...form.consultation, contact_methods: data });
                        }}
                      >
                        <img src={cm.icon} alt="Método de contacto" />
                        <span>{cm.label}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </section>
          )}

          {step === STEP.STEP6 && (
            <section>
              <h5>Datos bancarios</h5>

              <div className="grid-2 gap-x-4">
                <Select
                  className="speciality_select"
                  label="Banco"
                  name="bank_id"
                  onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                  value={form.bank_account.bank_id}
                  options={selects.banks}
                />

                <Input
                  color="white"
                  label="Número de cuenta"
                  placeholder="Número de cuenta"
                  name="number"
                  value={form.bank_account.number}
                  onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                />

                <div className="container-select">
                  <p className="label">C.I.</p>
                  <div>
                    <Select
                      className="document_type"
                      name="document_type_id"
                      value={form.bank_account.document_type_id}
                      options={selects.document_types}
                      onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                    />
                    <Input
                      type="number"
                      color="white"
                      placeholder="Documento"
                      name="document"
                      value={form.bank_account.document}
                      onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                    />
                  </div>
                </div>

                <div className="container-select">
                  <p className="label">Teléfono</p>
                  <div>
                    <Select
                      name="phone_code_id"
                      value={form.bank_account.phone_code_id}
                      options={selects.phonecodes}
                      onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                    />
                    <Input
                      type="number"
                      color="white"
                      name="phone"
                      placeholder="Teléfono"
                      value={form.bank_account.phone}
                      onChange={({ target }: any) => onChangeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

          {step === STEP.STEP7 && (
            <>
              <section>
                <h5>Información adicional</h5>

                <br />

                <div className="grid-3">
                  <div className="container-image">
                    <PaperClip
                      className="paperclip-image"
                      value={form.photo}
                      onChange={(e: any) => {
                        onChangeValue('photo', e.target);
                        onChangeValue('photo_blob', URL.createObjectURL(e.target.value));
                      }}
                    >
                      <FallbackImage
                        src={form.photo?.dataURL || form.photo_blob}
                        placeholder={WhiteImage}
                        className="selected-image"
                        placeholderClassName="selected-image inactive"
                        alt="Logo"
                      />
                    </PaperClip>
                    <p className="photo-title">Imagen publicitaria</p>
                  </div>

                  <div className="col-span-2">
                    <Textarea
                      label="Descripción de su empresa"
                      placeholder="Indique brevemente"
                      rows={3}
                      color="white"
                      name="description"
                      value={form.description}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </section>

              <section>
                <h5 className="d-flex">Aceptación de<span className="blue pl-1"><b>Términos y Condiciones</b></span></h5>
                <CheckboxRow
                  label="Declaro que toda la información proporcionada por mí, es veraz y completa."
                  checked={!!form.terms_truth}
                  onToggle={() => onChangeValue('terms_truth', !form.terms_truth)}
                />
                <CheckboxRow
                  label="Autorizo a iZoo a verificar toda la información suministrada ante las instituciones correspondientes."
                  checked={!!form.terms_verify}
                  onToggle={() => onChangeValue('terms_verify', !form.terms_verify)}
                />
                <CheckboxRow
                  label="Me comprometo a cumplir las leyes nacionales y las normas establecidas por iZoo App."
                  checked={!!form.terms_law}
                  onToggle={() => onChangeValue('terms_law', !form.terms_law)}
                />
              </section>
            </>
          )}

          <div className="actions">
            {step > STEP.STEP1 && (
              <Button onClick={prevStep}>
                Anterior
              </Button>
            )}
            <Button onClick={nextStep}>
              {step === STEP.STEP7 ? 'GUARDAR' : 'Siguiente'}
            </Button>
          </div>
        </div>
      </main>
    </div>
  )
}

export default RegisterClinic